import {log} from 'common/log'
import {SetCbMeta} from 'type/SetCb'
import {Key} from 'util/Key'
import {isKeyboardEvent} from 'util/event/isKeyboardEvent'

const focusableElementsSelector = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'

export type HTMLElementFocusable = HTMLAnchorElement | HTMLButtonElement | HTMLInputElement | HTMLTextAreaElement | HTMLDivElement
export function getFocusableElements(parentEl: HTMLElement): NodeListOf<HTMLElementFocusable> {
	return parentEl.querySelectorAll(focusableElementsSelector)
}

export function focusNextFormElement(hopCount: number, meta: SetCbMeta = {}, delay: number = 2) {
	const event = meta.event
	if (!hopCount || meta.skipFocusNext || event && (event?.type === 'blur' || isKeyboardEvent(event) && event.key === Key.Tab)) {
		log.trace('focusNextFormElement', 'skip', meta)
		return;
	}
	setTimeout(function () {
		let refElement = meta?.inputEl
		if (!refElement) refElement = document.activeElement as HTMLInputElement | null
		if (!refElement) {
			log.warn('focusNextFormElement', 'focusNextFormElement() skipped. refElement:', meta)
			return;
		}
		//add all elements we want to include in our selection
		const form = refElement && (refElement.form)
		if (form) {
			const f = getFocusableElements(form)
			const focusable = Array.prototype.filter.call(f,
				function (element: any) {
					//check for visibility while always include the current activeElement
					return element.offsetWidth > 0 || element.offsetHeight > 0 || element === refElement
				})
			const index = focusable.indexOf(refElement)
			if (index > -1) {
				const nextElement = focusable[index + hopCount]
				if (nextElement) {
					nextElement.focus()
					log.trace('focusNextFormElement', ' meta = ', meta, ' nextElement = ', nextElement)
				} else {
					refElement?.blur()
				}
			}
		} else if (!meta.focusNextOnlyInForm) {
			refElement.dispatchEvent?.(new KeyboardEvent("keypress", {
				key: "Tab",
			}));
			log.warn('focusNextFormElement', 'use form to group input elements to make use of "focusNextFormElement()"! Used meta:', meta)
		}
	}, delay) // timeout is required, because if focus next is triggered by Key.ENTER -> keystroke may get directed also to next element!
}